import { render, staticRenderFns } from "./paymentRefund.vue?vue&type=template&id=6bc82b59&"
import script from "./paymentRefund.vue?vue&type=script&lang=ts&"
export * from "./paymentRefund.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports